import Phaser from 'phaser'
import GameUtil from '../utils/game-util'

export default class BtnEndGame {
  /** @type Phaser.GameObjects.Graphics */
  BtnEndGame
  /**
   * @type {{
   *  context: Phaser.Scene
   *  handleOnClick: Function
   * }}
   */
  sceneContext = {}
  handleOnClick = () => {}

  /**
   *
   * @param {Phaser.Scene} context
   * @param {Function} handleOnClick
   */
  constructor(context, handleOnClick) {
    this.sceneContext = context
    this.handleOnClick = handleOnClick
  }

  create() {
    //finish button
    let buttonPosition = GameUtil.getViewPercentage(
      {
        X: this.sceneContext.isMobile ? 50 : 100,
        Y: this.sceneContext.isMobile ? 95 : 90,
      },
      this.sceneContext
    )

    this.BtnEndGame = this.sceneContext.add
      .sprite(buttonPosition.X, buttonPosition.Y, 'botonFinalizar')
      .setOrigin(this.sceneContext.isMobile ? 0.5 : 1, 1)
      .setInteractive({ cursor: 'pointer' })
      .on('pointerdown', this.handleOnClick, this.sceneContext)

    if (!this.sceneContext.isMobile) {
      Phaser.Display.Align.In.BottomCenter(
        this.BtnEndGame,
        this.sceneContext.pointsObj.PointsPlatform,
        0,
        110
      )
    }
  }
}
